import { InputHTMLAttributes, forwardRef, useId } from 'react'
import { cn } from '@/utils'

export type AppInputProps = InputHTMLAttributes<HTMLInputElement> & {
    label?: string
    error?: string
}

export const AppInput = forwardRef<HTMLInputElement, AppInputProps>(function AppInput({ className, label, error, ...props }, ref) {
    const id = useId()
    return (
        <div className={cn('flex flex-col gap-1', className)}>
            {label && (
                <label htmlFor={id} className="text-sm text-default/80">
                    {label}
                </label>
            )}
            <input
                id={id}
                ref={ref}
                className={cn(
                    'rounded-lg bg-default/5 px-3 py-2 text-sm transition-all duration-300 ease-in-out focus:opacity-100',
                    error ? 'border-red-500 border' : 'opacity-80',
                )}
                {...props}
            />
            {error && <p className="text-xs text-red-500">{error}</p>}
        </div>
    )
})
